import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './auth-context';

// Probably remove this
interface Props {
  children: React.ReactNode;
}

function AppProviders({ children }: Props) {
  return (
    <Router>
        <AuthProvider>{children}</AuthProvider>
    </Router>
  );
}

export { AppProviders };

